import { render, staticRenderFns } from "./FolderTree.vue?vue&type=template&id=bafca078"
import script from "./FolderTree.js?vue&type=script&lang=js&external"
export * from "./FolderTree.js?vue&type=script&lang=js&external"
import style0 from "./FolderTree.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports